import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchWithRetry } from 'src/utils/fetch-retry';
import { API_URL } from 'src/constants/other';

export const getMainData = createAsyncThunk(
  'data/getMainData',
  async (_, { rejectWithValue }) => {
    return fetchWithRetry(
      `${API_URL}/public/parties.json`,
    );
  }
);